import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  FormHelperText,
  Modal,
  Stack,
  TextField,
  Select,
  MenuItem,
  Typography,
  IconButton,
  FormControl,
  InputLabel,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";

import SearchFeild from "../Components/Table/SearchFeild";
import RecruiterTable, { schema } from "../Components/Table/RecruiterTable.jsx";
import ApiAlert from "../Components/AlertBox/ApiAlert";
import PeopleToNotifyRepeater from "./PeopleToNotifyRepeater.jsx";
import TemplateRepeater from "./TemplateRepeater.jsx";
import EmailRepeaters from "../Components/Repeaters/EmailRepeaters.jsx";
import ReuseableLabel from "../Components/ReusableComponents/ReuseableLabel.jsx";

import {
  getRecruitmentCompanyActionFn,
  postRecruitmentCompanyActionFn,
  editRecruitmentCompanyActionFn,
  deleteRecruitmentCompanyActionFn,
  getIflowChildCompanyUsingParentId,
} from "../Redux/RecruitmentCompany/action";
import { getCountryData } from "../Redux/Country/action";
import {
  editCompanyStatus,
  getHiringCompanyData,
  getHiringCompanyThroughData,
  getIflowHirngCompany,
  postHiringCompanyInFlow,
} from "../Redux/HiringCompany/action";
import {getChildCompanies, getCompanyNumber } from "../Redux/Templates/action";
import { getJobRoleData } from "../Redux/JobRole/action.js";
import { getQuestionsData } from "../Redux/Questions/action.js";
import { createNewOpeningActionFn } from "../Redux/QuestionPacakge/action.js";

import { useDebounce } from "../hooks/useDebounce.js";
import { useColorMode } from "../hooks/useColorMode.js";
import { validatePeopleToBeNotified } from "../constants/recruiterTab.js";
import { environmentDetails } from "../environment/environment";

const apiUrl = environmentDetails.apiUrl;

// Responsive style for the modal
const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "95vw", md: "70vw", lg: "60vw" },
  maxWidth: "900px",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: { xs: 2, md: 4 },
  borderRadius: "12px",
  maxHeight: "90vh",
  overflowY: "auto",
};

const RecruiterTabDashboard = () => {
  // All original logic, state, and functions remain unchanged
  var flag = 0;
  const dispatch = useDispatch();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [open, setOpen] = React.useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [alert, setAlert] = useState(false);
  const [alertContent, setalertcontent] = useState("");
  const [alertStatus, setAlertStatus] = useState(Boolean);
  const [search, setSearch] = useState("");
  const [masterCompanyId, setMasterCompanyId] = useState("");
  const [masterCompanyName, setMasterCompanyName] = useState("");
  const { getThemeColor } = useColorMode();
  const [template, setTemplate] = useState([
    {
      templateIndex: "",
      templateName: "",
      paramNumber: "",
      params: [],
      verbiage: "",
    },
  ]);
  const [newSubmit, setNewSubmit] = useState(false);
  const [countryDetails, setCountryDetails] = useState([]);
  const [countrySelected, setCountrySelected] = useState("");
  const [countryInternalSelected, setCountryInternalSelected] = useState("");
  const [phonePrefix, setPhonePrefix] = useState("");
  const [phonePrefixInternal, setPhonePrefixInternal] = useState("");
  const [recruiterCompanyDecLength, setRecruiterCompanyDecLength] = useState(0);
  const { debouncedValue } = useDebounce(search, 1500);
  const [notify, setNotify] = useState([
    { cname: "", cphone: "", email: "", cphonecode: countrySelected },
  ]);
  const [emailNotify, setEmailNotify] = useState([{ email: "" }]);
  const [peopleToNotifyAlert, setPeopleToNotifyAlert] = useState("");
  const [repeaterError, setRepeaterError] = useState(false);
  const [emailValidate, setEmailValidate] = useState(false);
  const [iflowCompanyId, setIflowCompanyId] = useState("");
  const [hiringCompanies, sethiringCompanies] = useState([]);
  const [metaCompanyDetails, setMetaCompanyDetails] = useState([]);
  const [metaRecruiterCompanyDetails, setMetaRecruiterCompanyDetails] =useState([]);
  const [filteredMetaCompany, setFilteredMetaCompany] = useState([]);

  const handleOpen = () => setOpen(true);

  useEffect(() => {
    const excludedIds = metaRecruiterCompanyDetails.map(
      (item) => item.childMetaCompany,
    );
    const filtered = metaCompanyDetails?.filter(
      (item) => !excludedIds.includes(item.id),
    );
    setFilteredMetaCompany(filtered);
  }, [metaRecruiterCompanyDetails, metaCompanyDetails]);

  const notifyInitialState = [
    { cname: "", cphone: "", email: "", cphonecode: countrySelected },
  ];
  const emailInitialState = [{ email: "" }];
  const templateInitialState = [
    {
      templateIndex: "",
      templateName: "",
      paramNumber: "",
      params: [],
      verbiage: "",
    },
  ];

  const [templateClick, setTemplateClick] = useState(false);
  const [conditionCheck, setConditionCheck] = useState(true);

  const initailState = {
    name: "",
    website: "",
    description: "",
    masterCompanyId: "",
    masterCompanyName: "",
    companyForHint: "",
    phone_number_id: "",
    phone_number_internal: "",
    phone_number: "",
    phone_number_id_internal: "",
    linkedinPage: "",
    instagramPage: "",
    careerPage: "",
    xHandle: "",
    reapplyDuration: "",
  };

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
    getValues,
    setValue,
    watch,
  } = useForm({
    defaultValues: initailState,
    resolver: yupResolver(schema),
  });

  const phoneNumber = watch("phone_number");
  const phoneNumberId = watch("phone_number_id");
  const phoneNumberInternal = watch("phone_number_internal");
  const phoneNumberIdInternal = watch("phone_number_id_internal");

  const [childCompanySelected, setChildCompanySelected] = useState("");
  const [recruiterCompanySelected, setRecruiterCompanySelected] = useState("");
  const [childCompanyDetails, setChildCompanyDetails] = useState("");
  const [recruiterCompanyDetails, setRecruiterCompanyDetails] = useState("");
  const [valuex, setValuex] = useState(null);
  const [iflowCompanyData, setIflowCompanyData] = useState("");
  const [iflowCompanyDataId, setIflowCompanyDataId] = useState("");

  // ... (All other logic functions remain unchanged)

  const handleClose = (flg) => {
    setOpen(false);
    setNewSubmit(false);
    reset(initailState);
    setMasterCompanyId("");
    setMasterCompanyName("");
    setNotify(notifyInitialState);
    setTemplate(templateInitialState);
    setEmailNotify(emailInitialState);
    setTemplateClick(false);
    setChildCompanyDetails("");
    setRecruiterCompanyDetails(null);
    setChildCompanySelected("");
    setRecruiterCompanySelected("");
    setCountrySelected("");
    setCountryInternalSelected("");
    setConditionCheck(true);
    setValuex(null);
    if (flg == "false") {
      console.log("delete recruiment company name to be implemented");
    }
  }; // get recruiter companies;
  // console.log("masterCompanyId", masterCompanyId);
  // console.log("iflowCompanyId", iflowCompanyId);
  const handleiFlowData = (valuex) => {
    dispatch(
      postHiringCompanyInFlow({
        resource: {
          name: valuex,
          code: null,
          friendlyname: valuex,
          parentid: iflowCompanyId,
          comptype: "CUSTOMER",
          contacts: [],
          aliases: [],
          vendorsapid: [],
          customersapid: [],
          accountManagers: [],
          otherEmails: [],
          otherPhoneNumbers: [],
          partnerLevel: "",
          addresses: [
            {
              line: "",
              country: "India",
              state: "",
              city: "",
              postalcode: "",
              type: "PA",
              friendlyaddress: "",
            },
          ],
          group: null,
          primaryEmailId: "",
          primaryPhoneNumber: "",
          registered: "India",
          employeeName: "",
          employeeAddress: "",
          dob: "",
          aadhaarId: "",
          panId: "",
          companyId: "",
          gstinIds: [],
          ieCode: "",
          blackList: false,
          isactive: true,
          aadhaar: {
            aadhaarId: "",
            name: "",
            address: "",
            gender: "",
            care_of: "",
            dob: "",
            email: "",
            id: "",
            message: "",
            mobile_hash: "",
            photo_link: "",
            ref_id: "",
            split_address: null,
            status: "",
            year_of_birth: "",
          },
          pan: {
            id: "",
            name: "",
            dob: "",
            fathersName: "",
          },
          flags: {
            mobilemsa: null,
            voicemsa: null,
            smsmsa: null,
            iotmsa: null,
            nda: null,
            ndaiot: null,
          },
          processName: "Initiation Process Pre-Screening",
        },
      }),
    )
      .then((res) => {
        if (res.type === "POST_IFLOWHIRINGCOMPANY_FAILURE") {
          setAlert(true);
          setAlertStatus(false);
          setalertcontent(res?.error);
          setValuex(null);
          return;
        } // console.log("dataGET", res.dataIflowHiringCompany);
        dispatch(getHiringCompanyThroughData(res?.dataIflowHiringCompany))
          .then((res) => {
            // console.log("helllooejdidbd", res?.idFlowHiringCompany?.code);
            // setAlert(true);
            // setAlertStatus(res.idFlowHiringCompany.status);
            // setalertcontent(res.idFlowHiringCompany.message);
            setIflowCompanyData(res?.payload?.code);
            setIflowCompanyDataId(res?.payload?.id);
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const iflowHiringcompanyData = useSelector(
    (state) => state.hiringCompanyReducer.iflowHiringCompany,
  );

  const iflowChildCompanyData = useSelector(
    (state) => state.recruitmentReducer?.iflowChildCompany,
  ); // console.log("childCompany",iflowChildCompanyData)
  useEffect(() => {
    dispatch(getIflowHirngCompany());
  }, []);

  useEffect(() => {
    // console.log("x",res?.idFlowHiringCompany?.id)
    // console.log("y",iflowCompanyId)

    if (
      masterCompanyId !== null &&
      masterCompanyId !== undefined &&
      masterCompanyId !== ""
    ) {
      if (masterCompanyId?.CompanyId != undefined) {
        dispatch(getHiringCompanyThroughData(masterCompanyId))
          .then((res) => {
            // console.log("CALLINGADDCHILDCOM", masterCompanyId);
            if (res?.idFlowHiringCompany?.id) {
              dispatch(
                getIflowChildCompanyUsingParentId(res?.idFlowHiringCompany?.id),
              ); // console.log("CALLINGADDCHILDCOMAFTER", masterCompanyId);
              setIflowCompanyId(res?.idFlowHiringCompany?.id); // console.log("getHiringCompanyThroughData",res?.idFlowHiringCompany?.id);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
  }, [masterCompanyId]);

  const recruitmentData = useSelector((state) => state.recruitmentReducer.data);
  const recruitmentDataLength = useSelector(
    (state) => state.recruitmentReducer.length,
  );

  useEffect(() => {
    dispatch(getHiringCompanyData(1, 5000)).then((res) => {
      sethiringCompanies(res.payload);
    });
  }, []);

  /*useEffect(() => {
    dispatch(getChildCompanies()).then((res) => {
      setMetaCompanyDetails(res.payload);
      dispatch(
        getRecruitmentCompanyActionFn(page + 1, 5000, debouncedValue),
      ).then((res) => {
        setMetaRecruiterCompanyDetails(res.payload);
      });
    });
  }, []);*/
  

  useEffect(() => {
 dispatch(getChildCompanies()).then((res) => {
  const companies = Array.isArray(res.payload)
  ? res.payload
  : Array.isArray(res.payload?.data)
    ? res.payload.data
    : [];

setMetaCompanyDetails(companies);

  //console.log("companies", companies);

    //console.log("companies", companies);
    dispatch(getRecruitmentCompanyActionFn(page + 1, 5000, debouncedValue)).then((res) => {
      const recruiters = Array.isArray(res.payload)
        ? res.payload
        : res.payload?.data || [];

      setMetaRecruiterCompanyDetails(recruiters);
    });
  });
}, []);


  useEffect(() => {
  if (childCompanySelected) {
    dispatch(getCompanyNumber(childCompanySelected)).then((res) => {
      const childDetails = res.payload?.[0];

      if (childDetails?.display_phone_number) {
        const parts = childDetails.display_phone_number.split(" ");

        setCountrySelected(parts[0]);

        setChildCompanyDetails({
          display_phone_number: parts[1] + (parts[2] || ""),
          internal_id: childDetails.id,
          id: childCompanySelected,
        });

        setValue("phone_number", parts[1] + (parts[2] || ""));
        setValue("phone_number_id", childDetails.id);
      }
    });
  }
}, [childCompanySelected]);

  useEffect(() => {
  if (recruiterCompanySelected) {
    dispatch(getCompanyNumber(recruiterCompanySelected)).then((res) => {
      const recruiterDetails = res.payload?.[0];

      if (recruiterDetails?.display_phone_number) {
        const parts = recruiterDetails.display_phone_number.split(" ");

        setCountryInternalSelected(parts[0]);

        setRecruiterCompanyDetails({
          display_phone_number: parts[1] + (parts[2] || ""),
          internal_id: recruiterDetails.id,
          id: recruiterCompanySelected,
        });

        setValue("phone_number_internal", parts[1] + (parts[2] || ""));
        setValue("phone_number_id_internal", recruiterDetails.id);
      }
    });
  }
}, [recruiterCompanySelected]);

  var updatedHiringCompanies = [];
  hiringCompanies?.forEach((val, key) => {
    if (val.companyStatus != false) {
      updatedHiringCompanies.push(val);
    }
  });

  const getRecruitmentCompanyFn = () => {
    dispatch(
      getRecruitmentCompanyActionFn(page + 1, rowsPerPage, debouncedValue),
    );
  };
  const compareStrings = (a, b) => {
    // Assuming you want case-insensitive comparison
    a = a.toLowerCase();
    b = b.toLowerCase();
    return a < b ? -1 : a > b ? 1 : 0;
  };

  let menustr = "";
  useEffect(() => {
    getRecruitmentCompanyFn();
    dispatch(getCountryData())
      .then((res) => {
        let countryData = res.payload;
        let newCountryData = [];
        countryData?.forEach((resp) => {
          if (resp.numeric_code == "356") {
            newCountryData.push(resp);
          }
          if (resp.numeric_code == "840") {
            newCountryData.push(resp);
          }
        });
        newCountryData.sort(function (a, b) {
          return compareStrings(a.name, b.name);
        });
        let newCountryData1 = countryData;
        newCountryData1.sort(function (a, b) {
          return compareStrings(a.name, b.name);
        });
        newCountryData1?.forEach((res) => {
          newCountryData.push(res);
        });
        setCountryDetails(newCountryData);
        setPhonePrefix(newCountryData[0]["phone_code"]);
        setPhonePrefixInternal(newCountryData[0]["phone_code"]);
        setCountrySelected(newCountryData[0]["phone_code"]);
        setCountryInternalSelected(newCountryData[0]["phone_code"]);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [page, rowsPerPage, debouncedValue, open]);

  useEffect(() => {
    if (peopleToNotifyAlert) {
      setTimeout(() => {
        setPeopleToNotifyAlert("");
      }, 4000);
    }
  }, [peopleToNotifyAlert !== "" ? true : false]);

  const jobRoles = useSelector((state) => state.jobRoleReducer.jobRoles);
  const defaultJobRole = jobRoles?.data?.filter(
    (el) => el?.role == "Any Open Position" || el?.jobId == "1704710825374",
  );

  const masterQuestions = useSelector(
    (state) => state.questionReducer.questions,
  );

  const [selectedQue, setSelectedQue] = useState([]);
  const defaultQuestions = masterQuestions?.filter(
    (el) => el.questionType === "Default Question",
  );

  let defaultQuestionData = [];

  defaultQuestions?.filter((val) => {
    if (val.qId == "1722000016999") {
      val["Attach Job Description"] = "y";
      if (defaultJobRole?.length > 0) {
        val.jdImage = environmentDetails.bucketURL + defaultJobRole[0]["image"];
        val["Job Description"] = defaultJobRole[0]["desc"];
      }
      val["Template Name"] = "abcd";
      defaultQuestionData.push(val);
    }
  });
  defaultQuestions?.filter((val) => {
    if (val.qId == "1721995896720") {
      defaultQuestionData.push(val);
    }
  });

  defaultQuestions?.map((val) => {
    if (val.qId != "1722000016999" && val.qId != "1721995896720") {
      defaultQuestionData.push(val);
    }
  });

  useEffect(() => {
    dispatch(getJobRoleData(1, 50000));
    dispatch(getQuestionsData(1, 50000));
    dispatch(getIflowHirngCompany());
  }, []);

  useEffect(() => {
    setValue("phone_number", childCompanyDetails?.display_phone_number);
    setValue("phone_number_id", childCompanyDetails?.internal_id);
    setValue(
      "phone_number_internal",
      recruiterCompanyDetails?.display_phone_number,
    );
    setValue("phone_number_id_internal", recruiterCompanyDetails?.internal_id);
  }, [childCompanyDetails]);

  const onSubmit = (data) => {
    setNewSubmit(true);
    var finalTemplateValues = {};
    template?.forEach((val) => {
      if (val.templateIndex != "") {
        finalTemplateValues[val.templateIndex] = {
          name: val.templateName,
          params: val.params.toString(),
          verbiage: val.verbiage,
        };
      }
    });

    let ress = validatePeopleToBeNotified(notify);
    if (!ress.status) {
      setPeopleToNotifyAlert(ress.message);
      setRepeaterError(true);
      return;
    }
    setRepeaterError(false);
    setPeopleToNotifyAlert(null);
    flag = false;
    emailNotify?.forEach((el) => {
      if (el.isDuplicate === true) {
        flag = true;
        return;
      }
    });
    if (flag === true) {
      setEmailValidate(true);
      return;
    }

    setEmailValidate(false);
    data = {
      ...data,
      masterCompanyId,
      masterCompanyName,
      companyId: valuex?.code || iflowCompanyData,
      emailIdToListen: emailNotify,
      peopleToBeNotified: notify,
      templates: finalTemplateValues,
      iFlowCompanyId: iflowCompanyDataId ? iflowCompanyDataId : valuex.id,
    };
    data.phone_number_prefix = phonePrefix;
    data.phone_number_internal_prefix = phonePrefixInternal;
    data.recruiterMetaCompany = recruiterCompanySelected;
    data.childMetaCompany = childCompanySelected;
    let companyId;
    let openingId = "null";
    dispatch(postRecruitmentCompanyActionFn(data))
      .then((res) => {
        companyId = res.payload.data.CompanyId;
        if (res.type === "POST_RECRUITMENT_COMPANY_SUCCESS") {
          setAlert(true);
          setNewSubmit(false);
          setAlertStatus(res.payload.status);
          setalertcontent(res.payload.message);
          reset(initailState);
          handleClose("true");
          setTemplateClick(true);
          dispatch(getRecruitmentCompanyActionFn());
          dispatch(
            createNewOpeningActionFn(openingId, {
              companyIds: [companyId],
              jobRoleId: defaultJobRole[0].jobId,
              selectedQuestionList: defaultQuestionData,
            }),
          ).then((res) => {
            console.log(res);
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
    handleClose("false");
  };

  const deleteRecruiterCompany = (companyId) => {
    dispatch(deleteRecruitmentCompanyActionFn(companyId))
      .then((res) => {
        setAlert(true);
        setAlertStatus(res.payload.status);
        setalertcontent(res.payload.message);
        setOpenDeleteModal(false);
        getRecruitmentCompanyFn();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  /*const editRecruiterCompanyDetails = (data) => {
    dispatch(editRecruitmentCompanyActionFn(data.CompanyId, data))
      .then((res) => {
        setAlert(true);
        setAlertStatus(res.payload.status);
        setalertcontent(res.payload.message);
        getRecruitmentCompanyFn();
      })
      .catch((err) => {
        console.log(err);
      });
  };*/
  const editRecruiterCompanyDetails = (data) => {
    dispatch(editRecruitmentCompanyActionFn(data.CompanyId, data))
      .then((res) => {
        setAlert(true);
        setAlertStatus(res.payload.status);
        setalertcontent(res.payload.message);
        getRecruitmentCompanyFn();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleEditOpen = (rowData) => {
    reset({
      name: rowData.name || "",
      website: rowData.website || "",
      description: rowData.description || "",
      companyForHint: rowData.companyForHint || "",
      phone_number: rowData.phone_number || "",
      phone_number_id: rowData.phone_number_id || "",
      phone_number_internal: rowData.phone_number_internal || "",
      phone_number_id_internal: rowData.phone_number_id_internal || "",
      linkedinPage: rowData.linkedinPage || "",
      instagramPage: rowData.instagramPage || "",
      careerPage: rowData.careerPage || "",
      xHandle: rowData.xHandle || "",
      reapplyDuration: rowData.reapplyDuration || "",
    });

    setMasterCompanyId(rowData.masterCompanyId || "");
    setMasterCompanyName(rowData.masterCompanyName || "");

    setRecruiterCompanySelected(rowData.recruiterMetaCompany || "");
    setChildCompanySelected(rowData.childMetaCompany || "");

    /*setRecruiterCompanyDetails({
      display_phone_number: rowData.phone_number_internal || "",
      internal_id: rowData.phone_number_id_internal || "",
      id: rowData.recruiterMetaCompany || "",
    });

    setChildCompanyDetails({
      display_phone_number: rowData.phone_number || "",
      internal_id: rowData.phone_number_id || "",
      id: rowData.childMetaCompany || "",
    });*/

    setCountrySelected(rowData.phone_number_prefix || "");
    setCountryInternalSelected(rowData.phone_number_internal_prefix || "");
    setNotify(rowData.peopleToBeNotified || notifyInitialState);
    setEmailNotify(rowData.emailIdToListen || emailInitialState);

    setOpen(true);
  };
  
  const handleChangeSwitch = (data) => {
    const status = !data.companyStatus;
    const id = data.CompanyId;
    dispatch(editCompanyStatus(id, status))
      .then((res) => {
        if (res.payload.status === 200) {
          setAlert(true);
          setAlertStatus(res.payload.data.status);
          setalertcontent(res.payload.data.message);
        } else {
          setAlert(true);
          setAlertStatus(res.payload.response.data.status);
          setalertcontent(res.payload.response.data.message);
        }
        setOpenDeleteModal(false);
        dispatch(getRecruitmentCompanyActionFn());
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const AlerthandleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert(false);
  };

  const handleDescriptionKeyUp = (event) => {
    setRecruiterCompanyDecLength(event.target.value.length);
  };

  const handlePhoneChange = (event) => {
    let phone_prefix = event.target.value;
    setPhonePrefix(phone_prefix);
  };

  const handlePhoneInternalChange = (event) => {
    let phone_internal_prefix = event.target.value;
    setPhonePrefixInternal(phone_internal_prefix);
  };

  const handleTemplate = () => {
    setValue("phone_number", childCompanyDetails.display_phone_number);
    setValue("phone_number_id", childCompanyDetails.internal_id);
    setValue(
      "phone_number_internal",
      recruiterCompanyDetails.display_phone_number,
    );
    setValue("phone_number_id_internal", recruiterCompanyDetails.internal_id);
    const formValues = getValues();
    if (templateClick === false) {
      if (
        formValues.phone_number?.length >= 10 &&
        formValues.phone_number_id?.length >= 10 &&
        formValues.phone_number_internal?.length >= 10 &&
        formValues.phone_number_id_internal?.length >= 10
      ) {
        setTemplateClick(true);
        setConditionCheck(true);
      } else {
        setConditionCheck(false);
      }
    } else if (templateClick === true) {
      setTemplateClick(false);
    }
  };

  const templateID = {
    childCompanyID: childCompanyDetails?.id,
    recruiterCompanyID: recruiterCompanyDetails?.id,
  };
   /*console.log("metaCompanyDetails", metaCompanyDetails);
  console.log("filteredMetaCompany", filteredMetaCompany);*/

  return (
    <>
      {alert && (
        <ApiAlert
          open={alert}
          snackbaronClose={AlerthandleClose}
          alertonClose={AlerthandleClose}
          alertType={alertStatus ? "success" : "error"}
          Content={alertContent}
        />
      )}
      <Box sx={{ width: "100%", height: "93dvh" }}>
        <SearchFeild
          buttonName="Add Recruitment Company"
          placeholder="Search Recruitment Company"
          width="100%"
          TextFieldWidth="70%"
          large="0px"
          Navigate={handleOpen}
          onChange={(e) => setSearch(e.target.value)}
          marginBottom={"15px"}
          roleModule="Recruitment Company"
        />
        <Modal
          open={open}
          aria-labelledby="add-recruitment-company-modal-title"
        >
          <Box sx={modalStyle}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <IconButton
                onClick={() => handleClose("false")}
                sx={{ position: "absolute", top: 8, right: 8 }}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Typography
                id="add-recruitment-company-modal-title"
                sx={{
                  fontSize: { xs: "24px", md: "30px" },
                  fontWeight: 600,
                  textAlign: "center",
                  mb: 3,
                  color: "primary.darkText",
                }}
              >
                Add Recruitment Company
              </Typography>

              <Stack spacing={2.5}>
                <Autocomplete
                  options={updatedHiringCompanies?.filter(
                    (el) => el.companyStatus,
                  )}
                  getOptionLabel={(option) => option.name || ""}
                  isOptionEqualToValue={(option, value) =>
                    option.CompanyId === value.CompanyId
                  }
                  onChange={(event, value) => {
                    setMasterCompanyId(value?.CompanyId || "");
                    setMasterCompanyName(value?.name || "");
                  }}
                  renderOption={(props, option) => (
                    <li {...props} key={option.CompanyId}>
                      {option.name}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<ReuseableLabel label={"Hiring Company"} />}
                      error={newSubmit && !masterCompanyId}
                      helperText={
                        newSubmit &&
                        !masterCompanyId &&
                        "Hiring Company is required"
                      }
                    />
                  )}
                />

                <Controller
                  name="name"
                  control={control}
                  render={({ field }) => (
                    <Autocomplete
                      freeSolo
                      options={iflowHiringcompanyData || []}
                      value={valuex || null}
                      onChange={(event, newValue) => {
                        // Clear
                        if (!newValue) {
                          setValuex(null);
                          field.onChange("");
                          return;
                        }

                        // User typed manually
                        if (typeof newValue === "string") {
                          // create new compnay in iflow db
                          handleiFlowData(newValue);
                          setValuex({
                            name: newValue,
                          });

                          field.onChange(newValue);

                          return;
                        }

                        // Existing company selected
                        setValuex(newValue);

                        field.onChange(
                          newValue?.name || newValue?.friendlyname || "",
                        );
                      }}
                      getOptionLabel={(option) => {
                        if (typeof option === "string") {
                          return option;
                        }

                        if (!option || typeof option !== "object") {
                          return "";
                        }

                        return (
                          option?.name?.trim() ||
                          option?.friendlyname?.trim() ||
                          option?.code?.trim() ||
                          `Company-${option?.id || ""}`
                        );
                      }}
                      isOptionEqualToValue={(option, value) =>
                        option?.id === value?.id
                      }
                      renderOption={(props, option) => (
                        <li {...props} key={option?.id}>
                          {option?.name ||
                            option?.friendlyname ||
                            option?.code ||
                            `Company-${option?.id}`}
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={
                            <ReuseableLabel
                              label={"Recruitment Company Name"}
                            />
                          }
                          error={!!errors.name}
                          helperText={errors.name?.message}
                        />
                      )}
                    />
                  )}
                />

                <TextField
                  fullWidth
                  label={<ReuseableLabel label={"Company Website"} />}
                  variant="outlined"
                  {...register("website")}
                  error={!!errors.website}
                  helperText={errors.website?.message}
                />
               

                <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
                  <Autocomplete
                    fullWidth
                    options={Array.from(
                      new Map(
                        (metaCompanyDetails || []).map((item) => [
                          item.id,
                          item,
                        ]),
                      ).values(),
                    )}
                    value={metaCompanyDetails.find(opt => opt.id === recruiterCompanySelected) || null}
                    getOptionLabel={(option) => option?.name || ""}
                    isOptionEqualToValue={(option, value) =>
                      option?.id === value?.id
                    }
                    onChange={(event, value) => {
                      setRecruiterCompanyDetails("");
                      setRecruiterCompanySelected(value?.id||"");
                    }}
                    renderOption={(props, option) => (
                      <li {...props} key={option.id}>
                        {option.name}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={
                          <ReuseableLabel
                            label={"Meta Company for Recruiter"}
                          />
                        }
                        error={newSubmit && !recruiterCompanySelected}
                        helperText={
                          newSubmit && !recruiterCompanySelected
                            ? "This field is required"
                            : ""
                        }
                      />
                    )}
                  />
                  <Autocomplete
                    fullWidth
                    options={Array.from(
                      new Map(
                        (metaCompanyDetails || []).map((item) => [
                          item.id,
                          item,
                        ]),
                      ).values(),
                    )}
                    value={metaCompanyDetails.find(opt => opt.id === childCompanySelected) || null}  
                    getOptionLabel={(option) => option?.name || ""}
                    isOptionEqualToValue={(option, value) =>
                      option?.id === value?.id
                    }
                    onChange={(event, value) => {
                      setChildCompanyDetails("");
                      setChildCompanySelected(value?.id||"");
                    }}
                    renderOption={(props, option) => (
                      <li {...props} key={option.id}>
                        {option.name}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={
                          <ReuseableLabel
                            label={"Meta Company for Candidate"}
                          />
                        }
                        error={newSubmit && !childCompanySelected}
                        helperText={
                          newSubmit && !childCompanySelected
                            ? "This field is required"
                            : ""
                        }
                      />
                    )}
                  />
                </Stack>

                <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
                  <FormControl sx={{ minWidth: 120, flexShrink: 0 }}>
                    <InputLabel>Code</InputLabel>

                    <Select
                      label="Code"
                      value={(countryInternalSelected || "").replace("+", "")}
                      onChange={(e) => {
                        setCountryInternalSelected(e.target.value);
                        handlePhoneInternalChange(e);
                      }}
                      renderValue={(selectedValue) => `+${selectedValue}`}
                    >
                      {Array.from(
                        new Map(
                          (countryDetails || []).map((item) => [
                            item.phone_code,
                            item,
                          ]),
                        ).values(),
                      ).map((res) => (
                        <MenuItem
                          key={`${res.iso2}-${res.phone_code}`}
                          value={String(res.phone_code).replace("+", "")}
                        >
                          <img
                            src={`https://catamphetamine.github.io/country-flag-icons/3x2/${
                              res.iso2 === "UM" ? "US" : res.iso2
                            }.svg`}
                            width="20"
                            style={{ marginRight: "8px" }}
                            alt={res.name}
                          />

                          {`+${String(res.phone_code).replace("+", "")}`}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <TextField
                    fullWidth
                    label={
                      <ReuseableLabel label={"WhatsApp Recruiter Connect #"} />
                    }
                    {...register("phone_number_internal")}
                    value={recruiterCompanyDetails?.display_phone_number || ""}
                    error={
                      (conditionCheck === false && !phoneNumberInternal) ||
                      !!errors.phone_number_internal
                    }
                    helperText={
                      conditionCheck === false && !phoneNumberInternal
                        ? "This field is required"
                        : errors.phone_number_internal?.message
                    }
                  />
                </Stack>

                <TextField
                  fullWidth
                  label={
                    <ReuseableLabel
                      label={"WhatsApp Recruiter Connect Meta ID"}
                    />
                  }
                  {...register("phone_number_id_internal")}
                  value={recruiterCompanyDetails?.internal_id || ""}
                  error={
                    (conditionCheck === false && !phoneNumberIdInternal) ||
                    !!errors.phone_number_id_internal
                  }
                  helperText={
                    conditionCheck === false && !phoneNumberIdInternal
                      ? "This field is required"
                      : errors.phone_number_id_internal?.message
                  }
                />

                <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
                  <FormControl sx={{ minWidth: 120, flexShrink: 0 }}>
                    <InputLabel>Code</InputLabel>

                    <Select
                      label="Code"
                      value={(countrySelected || "").replace("+", "")}
                      onChange={(e) => {
                        setCountrySelected(e.target.value);
                        handlePhoneChange(e);
                      }}
                      renderValue={(selectedValue) => `+${selectedValue}`}
                    >
                      {Array.from(
                        new Map(
                          (countryDetails || []).map((item) => [
                            item.phone_code,
                            item,
                          ]),
                        ).values(),
                      ).map((res) => (
                        <MenuItem
                          key={`${res.iso2}-${res.phone_code}`}
                          value={String(res.phone_code).replace("+", "")}
                        >
                          <img
                            src={`https://catamphetamine.github.io/country-flag-icons/3x2/${
                              res.iso2 === "UM" ? "US" : res.iso2
                            }.svg`}
                            width="20"
                            style={{ marginRight: "8px" }}
                            alt={res.name}
                          />

                          {`+${String(res.phone_code).replace("+", "")}`}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <TextField
                    fullWidth
                    label={
                      <ReuseableLabel label={"WhatsApp Candidate Connect #"} />
                    }
                    {...register("phone_number")}
                    value={childCompanyDetails?.display_phone_number || ""}
                    error={
                      (conditionCheck === false && !phoneNumber) ||
                      !!errors.phone_number
                    }
                    helperText={
                      conditionCheck === false && !phoneNumber
                        ? "This field is required"
                        : errors.phone_number?.message
                    }
                  />
                </Stack>

                <TextField
                  fullWidth
                  label={
                    <ReuseableLabel
                      label={"WhatsApp Candidate Connect Meta ID"}
                    />
                  }
                  {...register("phone_number_id")}
                  value={childCompanyDetails?.internal_id || ""}
                  error={
                    (conditionCheck === false && !phoneNumberId) ||
                    !!errors.phone_number_id
                  }
                  helperText={
                    conditionCheck === false && !phoneNumberId
                      ? "This field is required"
                      : errors.phone_number_id?.message
                  }
                />

                <TextField
                  fullWidth
                  label={<ReuseableLabel label={"Company Abbreviation"} />}
                  {...register("companyForHint")}
                  error={!!errors.companyForHint}
                  helperText={errors.companyForHint?.message}
                />

                <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                  <TextField
                    fullWidth
                    label="LinkedIn Page"
                    {...register("linkedinPage")}
                  />
                  <TextField
                    fullWidth
                    label="Instagram Page"
                    {...register("instagramPage")}
                  />
                </Stack>

                <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                  <TextField
                    fullWidth
                    label="Career Page"
                    {...register("careerPage")}
                  />
                  <TextField
                    fullWidth
                    label="X Handle"
                    {...register("xHandle")}
                  />
                </Stack>

                <FormControl fullWidth error={!!errors.reapplyDuration}>
                  <InputLabel id="reapply-duration-label">
                    <ReuseableLabel label={"Reapply Duration"} />
                  </InputLabel>
                  <Controller
                    name="reapplyDuration"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <Select
                        {...field}
                        labelId="reapply-duration-label"
                        label="Reapply Duration"
                      >
                        <MenuItem value="">
                          <em>Please select an option</em>
                        </MenuItem>
                        <MenuItem value={"0"}>0 day</MenuItem>
                        <MenuItem value={"15"}>15 days</MenuItem>
                        <MenuItem value={"30"}>30 days</MenuItem>
                        <MenuItem value={"90"}>90 days</MenuItem>
                        <MenuItem value={"180"}>180 days</MenuItem>
                        <MenuItem value={"365"}>365 days</MenuItem>
                      </Select>
                    )}
                  />
                  {errors.reapplyDuration && (
                    <FormHelperText>
                      {errors.reapplyDuration.message}
                    </FormHelperText>
                  )}
                </FormControl>

                <Box sx={{ position: "relative" }}>
                  <TextField
                    fullWidth
                    multiline
                    rows={4}
                    label="Company Description"
                    variant="outlined"
                    inputProps={{ maxLength: 4000 }}
                    {...register("description")}
                    onKeyUp={handleDescriptionKeyUp}
                  />
                  <Typography
                    variant="caption"
                    sx={{
                      position: "absolute",
                      bottom: 5,
                      right: 10,
                      color:
                        recruiterCompanyDecLength >= 4000
                          ? "error.main"
                          : "text.secondary",
                    }}
                  >
                    {recruiterCompanyDecLength}/4000
                  </Typography>
                </Box>

                <EmailRepeaters
                  emailFormValues={emailNotify}
                  setEmailFormValues={setEmailNotify}
                  emailValidate={emailValidate}
                  setEmailValidate={setEmailValidate}
                />

                <PeopleToNotifyRepeater
                  formValues={notify}
                  setFormValues={setNotify}
                  countryDetails={countryDetails}
                  countrySelected={countrySelected}
                  repeaterError={repeaterError}
                  setRepeaterError={setRepeaterError}
                />
                {peopleToNotifyAlert && (
                  <FormHelperText error>{peopleToNotifyAlert}</FormHelperText>
                )}

                <Box>
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography
                      sx={{ fontWeight: 600, color: "primary.darkText" }}
                    >
                      Meta Template
                    </Typography>
                    <Box
                      sx={{ flexGrow: 1, height: "1px", bgcolor: "grey.400" }}
                    />
                    <Tooltip
                      title={
                        !conditionCheck
                          ? "Please fill the required fields"
                          : templateClick
                            ? "Collapse"
                            : "Expand"
                      }
                    >
                      <IconButton onClick={handleTemplate} size="small">
                        {templateClick ? (
                          <RemoveCircleIcon color="action" />
                        ) : (
                          <AddCircleIcon color="action" />
                        )}
                      </IconButton>
                    </Tooltip>
                  </Stack>
                  {templateClick && (
                    <TemplateRepeater
                      templateValues={template}
                      setTemplateValues={setTemplate}
                      templateID={templateID}
                    />
                  )}
                </Box>

                <Stack
                  direction={{ xs: "column-reverse", sm: "row" }}
                  justifyContent="flex-end"
                  spacing={2}
                  sx={{ pt: 2 }}
                >
                  <Button
                    onClick={() => handleClose("false")}
                    variant="contained"
                    color="secondary"
                    sx={{ textTransform: "none" }}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    sx={{ textTransform: "none" }}
                  >
                    Save
                  </Button>
                </Stack>
              </Stack>
            </form>
          </Box>
        </Modal>
        <RecruiterTable
          recruitmentData={recruitmentData}
          handleChangeSwitch={handleChangeSwitch}
          open={openDeleteModal}
          setOpen={setOpenDeleteModal}
          editRecruiterCompanyDetails={editRecruiterCompanyDetails}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          recruitmentDataLength={recruitmentDataLength}
          countryDetails={countryDetails}
          countrySelected={countrySelected}
        />
      </Box>
    </>
  );
};

export default RecruiterTabDashboard;
